// extracted by mini-css-extract-plugin
export default {"statusTag":"src-pages-SalesCannelVersion-SalesChannelSettings-SalesChannelCommunication-Components-StatusTag-css-module__statusTag--pCV6m"};